// The bussines logic for webinar evaluation is in https://jmarquardt.atlassian.net/browse/JMT-10687?filter=17470.

// x-filter in header comes as stringified JSON object:
const getXFilter = (apiDataItem) => {
  let xFilter;
  try {
    xFilter = JSON.parse(apiDataItem?.headers?.['x-filter']);
  } catch {
    console.log('VM2 - cannot parse x-filter in isErrorNotEnoughtTime from: ', {
      apiDataItem
    });
  }

  return xFilter;
};

// Implements business logic to check if there are any unanswered questions.
export const hasUnfinishedEvaluation = (apiDataItem) => {
  const result = getXFilter(apiDataItem)?.result ?? {};

  // We must check for equality to 0 to avoid confusion if the `done` is undefined.
  // In such case missing done would be interpreted as the evaluation wad be done.
  return Object.values(result).some(({ done }) => done === 0);
};

// Test if the text of error in header x-Filter signals an error:
// RegExp test function can accept any type of variable, so no need to safeguard argument.
// This is according to the ticket https://jmarquardt.atlassian.net/browse/JMT-10687?filter=17470
export const isErrorNotEnoughtTime = (apiDataItem) => /^no enough time/.test(getXFilter(apiDataItem)?.error);

/**
 * Extracts the time watched and time required from the "no enough time" error message.
 * The error string is expected to be in the format: "no enough time, 120 of 600"
 * @param {object} apiDataItem The API data item containing the headers.
 * @returns {{watched: number, required: number} | null} An object with watched and required times, or null if the format doesn't match.
 */

export const getEvaluationTime = (apiDataItem) => {
  const errorString = getXFilter(apiDataItem)?.error;

  if (!errorString) {
    return null;
  }

  const match = errorString.match(/^no enough time, (\d+) of (\d+)/);

  if (match && match.length === 3) {
    const watched = parseInt(match[1], 10);
    const required = parseInt(match[2], 10);

    // Ensure the parsed values are valid numbers using the stricter Number.isNaN
    if (!Number.isNaN(watched) && !Number.isNaN(required)) {
      return { watched, required };
    }
  }

  return null;
};
